import { useRouter } from 'next/router';

export const useQueryParams = () => {
  const {
    query,
    push,
    pathname,
  } = useRouter();
  const addQueryParams = (
    newQuery: { [key: string]: string | number | Array<string> },
    queryToRemoveKeys: Array<string> = []
  ) => {
    const currentQueriesEntries = new Map(Object.entries(query) || []);

    [...queryToRemoveKeys].forEach(key => currentQueriesEntries.delete(key));

    const filteredQueries = Object.fromEntries(currentQueriesEntries);

    push(
      {
        pathname,
        query: {
          ...filteredQueries,
          ...newQuery,
        },
      },
      undefined,
      { shallow: true }
    );
  };

  const getQueryParams = (paramKey: string): string | Array<string> | undefined => {
    const queryParam = query[paramKey];

    return queryParam;
  };

  const removeQueryParam = (objectKeyToRemove: string | number) => {
    if (query[objectKeyToRemove]) {
      const updatedQuery = { ...query };

      delete updatedQuery[objectKeyToRemove];

      push(
        {
          pathname,
          query: updatedQuery,
        },
        undefined,
        { shallow: true }
      );
    }
  };

  return {
    addQueryParams,
    getQueryParams,
    removeQueryParam,
  };
};
